import { render } from "./mvt-mortgage-new.vue?vue&type=template&id=0a8917d4"
import script from "./mvt-mortgage-new.js?vue&type=script&lang=js"
export * from "./mvt-mortgage-new.js?vue&type=script&lang=js"

import "./mvt-mortgage-new.vue?vue&type=style&index=0&id=0a8917d4&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__